import Konva from "konva";

export default class TextOffscreen {
  constructor(stage) {
    this.stage = stage.clone();
    this.stage.x(0);
    this.stage.y(0);
    this.stage.offsetX(0);
    this.stage.offsetY(0);
    this.stage.scaleX(1);
    this.stage.scaleY(1);
    // TODO text offscreen canvas sizeが適当
    this.stage.width(600);
    this.stage.height(600);

    this.textLayer = new Konva.Layer({

    });
    this.stage.add(this.textLayer);
  }

  copy(text, scale = 2){
    this.textLayer.removeChildren();
    let cloneText = text.clone();
    const textScale = cloneText.scale();
    cloneText.scale({x: textScale.x * scale, y: textScale.y * scale});
    cloneText.x(cloneText.x() * scale);
    cloneText.y(cloneText.y() * scale);
    this.textLayer.add(cloneText);
    this.textLayer.batchDraw();
    this.stage.batchDraw();
    return cloneText;
  }

  toCanvas(){
    return this.stage.toCanvas();
  }
  toDataURL(){
    return this.stage.toDataURL()
  }
}
